export default __webpack_public_path__ + "static/thumbnail_VerifyTrusted2_Balgores_2024-4551ba44750e0282a0377cc60541dad0.png";